import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AgentResponse} from '../models/agent.model';
import {AuthService} from "./auth.service";

@Injectable({
    providedIn: 'root',
})
export class HstService {
    private readonly http = inject(HttpClient);
    private readonly authService = inject(AuthService);

    private getHeaders(): HttpHeaders {
        const token = this.authService.getAccessToken() || '';
        const host = window.location.hostname.toLowerCase();
        const domainExt = host.match(/\.(com|net)/)?.[0] || '';
        const domainStr = domainExt === '.com' ? 'com' : 'net';

        let headers = new HttpHeaders()
            .set('Authorization', `${token}`)
            .set('domain', domainStr);

        return headers;
    }

    getDealerList(): Observable<AgentResponse> {
        const url = 'hst/agent-list';
        return this.http.get<AgentResponse>(url, {headers: this.getHeaders()});
    }

    getUserAgentList(userId: string): Observable<AgentResponse> {
        const url = 'hst/user-agent-list';
        return this.http.post<AgentResponse>(url, {userId: userId}, {headers: this.getHeaders()});
    }
}
